import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import VehicleSaleSearch from '../../search/VehicleSaleSearch';

export default function FormInputVehicleSaleSearch(props) {
  return <FormInputSearch {...props} searchComponent={VehicleSaleSearch} />;
}
